/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, September 8th 2022, 5:10:12 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import HelpIcon from "@mui/icons-material/Help";
import { FullScreenNotificationGrid, Image, OSDialog } from "ui-widgets";

interface HelpDialogWrapperProps {
  helpTitle: React.ReactNode;
  helpContent: React.ReactNode;
  helpIllustration?: React.ReactNode;
  helpTooltipText?: React.ReactNode;
  helpButtonIcon?: React.ReactNode;
}

export const GeneralHelpDialogWrapper = ({
  helpTitle,
  helpContent,
  helpButtonIcon,
  helpIllustration,
  helpTooltipText,
}: HelpDialogWrapperProps) => {
  return (
    <OSDialog
      open={false}
      renderOpenButton={({ handleOpen }) => (
        <Tooltip title={helpTooltipText ?? <Typography> Help Info</Typography>} arrow>
          <IconButton onClick={handleOpen} color="primary">
            {helpButtonIcon ?? <HelpIcon />}
          </IconButton>
        </Tooltip>
      )}
    >
      <FullScreenNotificationGrid
        pageTitle={helpTitle}
        pageContent={<p style={{ padding: "0px 0px 20px 0px" }}>{helpContent}</p>}
        pageIllustration={helpIllustration ?? <Image src="/img/information.png" />}
      />
    </OSDialog>
  );
};

interface InputHelpDialogWrapperProps extends HelpDialogWrapperProps {
  children: React.ReactNode;
}

export const InputHelpDialogWrapper = ({ children, ...generalHelpDialogProps }: InputHelpDialogWrapperProps) => {
  return (
    <Stack direction="row">
      <div style={{ flex: 20 }}>{children}</div>
      <div style={{ flex: 1, paddingTop: 6 }}>
        <GeneralHelpDialogWrapper {...generalHelpDialogProps} />
      </div>
    </Stack>
  );
};
